import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setRouterBackHandler } from "@app/back";
import { AppPaths } from "./paths";

/**
 * Регистрирует router fallback для `App Back` (нижняя кнопка «Назад» на ТСД).
 */
export const NavigationBridge: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setRouterBackHandler(() => {
            if (window.history.state?.idx > 0) {
                navigate(-1);
                return;
            }

            if (location.pathname !== AppPaths.MENU) {
                navigate(AppPaths.MENU, { replace: true });
            }
        });

        return () => {
            setRouterBackHandler(null);
        };
    }, [location.pathname, navigate]);

    return null;
};
